import React from 'react';

import './cloudstyle.scss';
import cloudImg from '../../../assets/images/svg/cloud.svg';

const Cloud = ({ type = 'move', style }) => {
  return (
    <img
      alt="cloud"
      className={`cloud ${type}`}
      loading="lazy"
      src={cloudImg}
      style={{
        ...style,
      }}
    />
  );
};

export default Cloud;
